import { gql } from "@apollo/client";

export const LearnFragment = gql`
  fragment LearnFragment on Learn {
    completed
    completedAt
    users_permissions_user {
      data {
        id
      }
    }
    course {
      data {
        id
        attributes {
          title
          slug
          description
          thumbnail {
            data {
              attributes {
                url
                alternativeText
                mime
              }
            }
          }
          course_category {
            data {
              attributes {
                name
                description
              }
            }
          }
          modules {
            id
            title
            moduleStableId
            lessons {
              id
              title
              lessonStableId
              authors {
                data {
                  attributes {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
    learn_items: learn_items_connection(pagination: { limit: 999 }) {
      data {
        attributes {
          idModule
          idLesson
        }
      }
    }
  }
`;
